const isPlainValue = (value) =>
  value === undefined || typeof value === 'string' || typeof value === 'boolean';

export default isPlainValue;
